export default __webpack_public_path__ + "static/media/InsideBlood_08.72025afa.png";